(function () {
  const input = document.getElementById('aneezay-search-input');
  const list = document.getElementById('aneezay-search-list');
  const empty = document.querySelector('.aneezay-search__empty');
  let debounceTimer;
  let currentController;

const money = (amount) => {
  const value = Number(amount) || 0;
  const hasCents = value % 1 !== 0;
  const formatted = value.toLocaleString('en-US', {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  });
  return `Rs ${formatted}`;
};

  const renderResults = (products) => {
    list.innerHTML = '';

    if (!products.length) {
      list.hidden = true;
      empty.hidden = false;
      input.setAttribute('aria-expanded', 'false');
      return;
    }

    empty.hidden = true;
    list.hidden = false;
    input.setAttribute('aria-expanded', 'true');

    products.forEach((product) => {
      const li = document.createElement('li');
      li.setAttribute('role', 'option');
      li.className = 'aneezay-search__item';

      const priceHtml = product.compare_at_price_max > product.price_max
    ? `<span class="aneezay-search__price-sale">${money(product.price_max)}</span>
       <span class="aneezay-search__price-compare">${money(product.compare_at_price_max)}</span>`
    : `<span class="aneezay-search__price">${money(product.price_max)}</span>`;

      li.innerHTML = `
        <a href="${product.url}" class="aneezay-search__link">
          <span class="aneezay-search__thumb">
            ${product.image
              ? `<img src="${product.image}" alt="${product.title}" width="56" height="56" loading="lazy">`
              : ''}
          </span>
          <span class="aneezay-search__meta">
            <span class="aneezay-search__title">${product.title}</span>
            <span class="aneezay-search__price-wrap">${priceHtml}</span>
          </span>
        </a>
      `;
      list.appendChild(li);
    });
  };

  const fetchResults = async (query) => {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    try {
      const res = await fetch(
      `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,vendor&resources[options][unavailable_products]=last`
    );
      const data = await res.json();
      const products = data.resources.results.products.map((p) => ({
        title: p.title,
        url: p.url,
        image: p.featured_image ? p.featured_image.url : (p.image || null),
        price_max: p.price_max ?? p.price,
        compare_at_price_max: p.compare_at_price_max ?? null,
      }));
      renderResults(products);
    } catch (err) {
      if (err.name !== 'AbortError') console.error('Predictive search failed', err);
    }
  };

  input?.addEventListener('input', (e) => {
    const query = e.target.value.trim();
    clearTimeout(debounceTimer);

    if (query.length < 2) {
      list.hidden = true;
      empty.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      return;
    }

    debounceTimer = setTimeout(() => fetchResults(query), 220);
  });

  // Keyboard navigation
  input?.addEventListener('keydown', (e) => {
    const items = list.querySelectorAll('.aneezay-search__item');
    if (!items.length) return;
    const active = list.querySelector('.aneezay-search__item.is-active');
    let index = Array.from(items).indexOf(active);

    if (e.key === 'ArrowDown') {
      e.preventDefault();
      index = (index + 1) % items.length;
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      index = (index - 1 + items.length) % items.length;
    } else if (e.key === 'Enter' && active) {
      e.preventDefault();
      active.querySelector('a').click();
      return;
    } else {
      return;
    }

    items.forEach((i) => i.classList.remove('is-active'));
    items[index].classList.add('is-active');
    items[index].scrollIntoView({ block: 'nearest' });
  });
})();